import { jump, getDataThrowToMicroapp } from '@/pages/activity-manage/merchants/venue-detail/constants/index';
import type { DataType } from '@/pages/activity-manage/merchants/venue-detail/constants/index';
import { getQuery, pushQuery } from '@/common/utils';

const baseLink = '/activity-manage/myCreate/daily-activities-manager';

const data = getDataThrowToMicroapp({ baseLink });

const _data: DataType = {
  ...data,
  sence: 'daily',
  // 收品池列表
  jumpCollection(query, type) {
    jump(baseLink + '/materials/distribute/roomlist' + query + '&receivingType=1', type);
  },
  // 收品池列表
  jumpInvite(query, type) {
    jump(baseLink + '/materials/invite/roomlist' + query + '&receivingType=2', type);
  },
  // 收品池列表
  jumpPoolList(query, type) {
    jump(baseLink + '/materials/distribute/roomlist' + query, type);
  },
  jumpEffectData(query, type) {
    jump(baseLink + '/materials/distribute/effectdata' + query, type);
  },
  // 跳转潘多拉
  jumpPandora(query, type) {
    jump(baseLink + '/pandora/#' + query, type);
  },
  jumpActivityData(query, type) {
    // 我和上面的如果没有流程数据就可以删掉了
    jump(baseLink + '/materials/distribute/manage/activityData/detail' + query, type);
  },
  jumpManage(query, type) {
    jump(baseLink + '/managemc' + query, type);
  },
  // 新增选品助手
  jumpSelectSetting(query, type) {
    let link = baseLink + '/selectSetting' + query;
    link = pushQuery(link, 'activityId=' + getQuery('activityId'));
    link = pushQuery(link, 'blockId=' + getQuery('blockId'));

    jump(link, type);
  },

  // jumpMaterialsGroup(query, type) {
  //   jump(baseLink + '/materials' + query, type);
  // },
  // jumpDailyGoodsStrategyNew(query, type) {
  //   jump(baseLink + '/strategy-new' + query, type);
  // },
  // jumpDailyGoodsStrategySet(query, type) {
  //   jump(baseLink + '/strategy-set' + query, type);
  // },
  // jumpStrategyGoodsRange(query, type) {
  //   jump(baseLink + '/strategy-goods-range' + query, type);
  // },
  // jumpDailyGoodsStrategyDetail(query, type) {
  //   jump(baseLink + '/strategy-touch-detail' + query, type);
  // },
  // jumpStrategyDailyGoodSet(query, type) {
  //   jump(baseLink + '/strategy-daily-good-set' + query, type);
  // },
  // jumpStrategyDailyGoodDetail(query, type) {
  //   jump(baseLink + '/strategy-daily-good-detail' + query, type);
  // },
  // jumpDailyMaterialPoolManage(query, type) {
  //   jump(baseLink + '/strategy' + query, type);
  // },
  // // 点击换品跳转换品页
  // jumpSignup(query, type) {
  //   jump(baseLink + '/signup' + query, type);
  // },
};

export default _data;
